<template>
  <div>
    <LayoutHeadBannerWithoutLinks
      v-if="_.get(this.$store.state.current_content, 'secondary.LayoutHeadBannerWithoutLinks.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.LayoutHeadBannerWithoutLinks.data')"
    />
    <Breadcrumb />
    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <h2 class="other-title">Product Info</h2>
        <div class="text mt-21">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus risus metus, dapibus ac vehicula
          hendrerit,
          feugiat
          eu sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Ut suscipit diam non viverra
          aliquam.
          Quisque
          ut neque neque. Nunc vel convallis purus. Sed congue nisl ac nibh mollis pellentesque. Nulla congue
          purus
          felis,
          sed
          luctus risus molestie in.
          Nam quis est vel quam consequat hendrerit. Donec eget tempus sem. Vestibulum vel urna magna. Etiam
          vulputate
          consequat justo vitae blandit. Morbi auctor ipsum neque, quis lobortis mauris laoreet et. Donec at nulla
          cursus,
          tincidunt felis ac, posuere diam. Etiam laoreet, metus ac lacinia maximus, lectus velit porta risus, eu
          imperdiet
          elit leo et justo. Integer sit amet nisl id nisi venenatis ullamcorper sed quis urna.
        </div>
        <div class="simple-list-2 mt-34">
          <SimpleList />
        </div>

        <h2 class="other-title mt-34">Product Info</h2>
        <div class="text mt-21">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus risus metus, dapibus ac vehicula
          hendrerit,
          feugiat
          eu sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Ut suscipit diam non viverra
          aliquam.
          Quisque
          ut neque neque. Nunc vel convallis purus. Sed congue nisl ac nibh mollis pellentesque. Nulla congue
          purus
          felis,
          sed
          luctus risus molestie in.
          Nam quis est vel quam consequat hendrerit. Donec eget tempus sem. Vestibulum vel urna magna. Etiam
          vulputate
          consequat justo vitae blandit. Morbi auctor ipsum neque, quis lobortis mauris laoreet et. Donec at nulla
          cursus,
          tincidunt felis ac, posuere diam. Etiam laoreet, metus ac lacinia maximus, lectus velit porta risus, eu
          imperdiet
          elit leo et justo. Integer sit amet nisl id nisi venenatis ullamcorper sed quis urna.
        </div>
        <ScrollList />
      </div>
      <div class="layout-right small">
        <h3 class="transfer-title font-21 noto-semibold">Other Money Transfers</h3>
        <div class="right-column">
          <HighlightsBox />
          <HighlightsBox />
          <HighlightsBox />
          <HighlightsBox />
          <HighlightsBox />
        </div>
      </div>
    </div>

    <NewsAndMedia
      v-if="_.get(this.$store.state.current_content, 'secondary.NewsAndMedia.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.NewsAndMedia.data')"
    />
    <DirectCallBanner
      v-if="_.get(this.$store.state.current_content, 'secondary.DirectCallBanner.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.DirectCallBanner.data')"
    />
  </div>
</template>


<script>
import LayoutHeadBannerWithoutLinks from "@/components/LayoutHeadBannerWithoutLinks";
import Breadcrumb from "@/components/Breadcrumb";
import SimpleList from "@/components/SimpleList";
import ScrollList from "@/components/ScrollList";
import HighlightsBox from "@/components/HighlightsBox";
import NewsAndMedia from "@/components/NewsAndMedia";
import DirectCallBanner from "@/components/DirectCallBanner";

export default {
  components: {
    LayoutHeadBannerWithoutLinks,
    Breadcrumb,
    SimpleList,
    ScrollList,
    HighlightsBox,
    NewsAndMedia,
    DirectCallBanner,
  },
};
</script>
